var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoiceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3459_5952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.68 1.6665C15.7525 1.6665 15 3.90484 15 6.6665H16.68C17.49 6.6665 17.8942 6.6665 18.145 6.38734C18.395 6.10734 18.3517 5.739 18.265 5.00317C18.0333 3.05817 17.4117 1.6665 16.68 1.6665Z",
    strokeWidth: 1.5,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9993 6.7115V15.5382C14.9993 16.7973 14.9993 17.4273 14.6143 17.6757C13.9852 18.0807 13.0127 17.2307 12.5235 16.9223C12.1193 16.6673 11.9177 16.5407 11.6935 16.5332C11.451 16.5248 11.2452 16.6473 10.8085 16.9223L9.21602 17.9265L9.20805 17.9315C8.78336 18.199 8.57037 18.3332 8.33268 18.3332C8.09376 18.3332 7.87895 18.1976 7.45066 17.9273L7.44935 17.9265L5.85768 16.9223C5.45268 16.6673 5.25102 16.5407 5.02685 16.5332C4.78435 16.5248 4.57852 16.6473 4.14185 16.9223C3.65268 17.2307 2.68018 18.0807 2.05018 17.6757C1.66602 17.4273 1.66602 16.7982 1.66602 15.5382V6.7115C1.66602 4.33317 1.66602 3.14484 2.39852 2.40567C3.13018 1.6665 4.30935 1.6665 6.66602 1.6665H16.666M4.99935 4.99984H11.666M6.66602 8.33317H4.99935",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.416 9.06217C9.72602 9.06217 9.16602 9.55217 9.16602 10.1563C9.16602 10.7597 9.72602 11.2497 10.416 11.2497C11.106 11.2497 11.666 11.7397 11.666 12.3438C11.666 12.9472 11.106 13.4372 10.416 13.4372M10.416 9.06217C10.9602 9.06217 11.4235 9.36634 11.5952 9.79134M10.416 9.06217V8.33301M10.416 13.4372C9.87185 13.4372 9.40852 13.133 9.23685 12.708M10.416 13.4372V14.1663",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3459_5952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIcon);
export default __webpack_public_path__ + "static/media/invoice_icon.b9f2e952b5a5b0dd382a31c59dfbffc4.svg";
export { ForwardRef as ReactComponent };